import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';

const LATEST_RELEASE_HEADING = /^## \[(.*?)\] - (\d{4}-\d{2}-\d{2})/m;

@Injectable({ providedIn: 'root' })
export class ChangelogService {
  private readonly http = inject(HttpClient);

  private readonly appVersionSignal = signal('');
  private readonly releaseDateSignal = signal('');

  readonly appVersion = this.appVersionSignal.asReadonly();
  readonly releaseDate = this.releaseDateSignal.asReadonly();

  constructor() {
    this.http.get('assets/CHANGELOG.md', { responseType: 'text' }).subscribe((content) => {
      const match = LATEST_RELEASE_HEADING.exec(content);
      if (match) {
        this.appVersionSignal.set(match[1]);
        this.releaseDateSignal.set(match[2]);
      }
    });
  }
}
